import React from 'react';
import dayjs from 'dayjs';
import type { ActionEntity } from './hooks/useScopedActionForm';
import { formatActionTask } from './utils/actionTask';

type ActionPopupContentProps = {
  action: ActionEntity;
};

const formatDate = (date: Date | string | null | undefined) =>
  date && dayjs(date).isValid() ? dayjs(date).format('MM/DD/YYYY HH:mm') : '—';

const Field: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <div className="mb-2">
    <div className="text-muted small">{label}</div>
    <div>{children}</div>
  </div>
);

export const ActionPopupContent: React.FC<ActionPopupContentProps> = ({
  action,
}) => {
  const assignee =
    action.poc_user_name || action.user_name || action.poc || 'Unassigned';
  const geolocation = (action as { geolocation?: unknown }).geolocation as
    | { address?: string; name?: string }
    | null
    | undefined;
  const locationLabel =
    geolocation?.address ||
    geolocation?.name ||
    (geolocation ? 'Map location set' : '—');

  return (
    <div style={{ maxWidth: '360px', color: '#fff' }}>
      <div className="fw-semibold mb-3">
        {formatActionTask(action.name, action.description)}
      </div>
      <Field label="Status">{action.status || '—'}</Field>
      <Field label="Assignee">{assignee}</Field>
      <Field label="Briefed POC">{action.briefed_poc ? 'Yes' : 'No'}</Field>
      <Field label="Start">{formatDate(action.start_date)}</Field>
      <Field label="Due">{formatDate(action.target_date)}</Field>
      <Field label="Location">{locationLabel}</Field>
    </div>
  );
};
